

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { ShareOptions } from './types'
import { defaultShareConfig } from './config'
import { ShareConfigItem } from '@/modules/marketing/activity/component/shareAppMessage/types'

@Component
export default class ShareAppMessage extends Vue {
  @Prop(Boolean)
  visible !: false

  @Prop(Object)
  shareOptions !: ShareOptions

  @Prop({
    type: Array,
    default: () => {
      return defaultShareConfig
    }
  })
  shareConfig !: []

  @Watch('shareOptions', { deep: true })
  onVisibleChange(n: ShareOptions) {
    if (!n.title) return
    this.setShareMessage()
  }

  close() {
    this.$emit('update:visible', false)
  }

  /**
   * 处理分享路径
   * @param item
   */
  handleClickShare(item: ShareConfigItem) {
    item.onClick && item.onClick(this.shareOptions)
    this.close()
  }

  /**
   * 设置分享内容
   */
  setShareMessage() {
    const { title, abstract, own_url, image_url } = this.shareOptions
    // @ts-ignore
    this.$wechat.promise.then(wx => {
      // 处理分享到朋友圈
      wx.shareTimeline({
        title, // 分享标题
        link: own_url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: image_url // 分享图标
      })
      // 处理分享给好友
      wx.shareAppMessage({
        title,
        desc: abstract,
        link: own_url,
        imgUrl: image_url
      })
      // wx.shareWechat(opt)
    }, (wx: { res: any; }) => {
      // 抛出异常
      throw new Error(`微信JSSDK校验错误:${JSON.stringify(wx.res)}`)
    })
  }
}
